import { useValidate } from "formvalidation/hooks";
import axios from "axios";
import React, { useRef } from "react";
import { useCustomQuery } from "utilities/hookutils";
import { saveOrCancel } from "utilities/inputUtils";
import { useClientId } from "common/SessionContext";
import { InputBase } from "components/Atoms/formInputs/InputBase";

interface ICalendarInputProps {
  validatorKey: string
  peekICalendarUrl: string
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  onEnter?: () => void
  onEsc?: () => void
  onOutcomeChange?: (outcome: server.dto.ApiResponseWrapper<server.dto.ExternalCalendarPeek>) => void
  focusOnMount?: boolean
}

export const ICalendarUrlInput = (props: ICalendarInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const clientId = useClientId();

  const iCalendarUrlValidator = useCustomQuery({
    queryKey: ["iCalendarUrlValidator", props.value],
    queryFn: async () => {
      const response = await axios.post<server.dto.ApiResponseWrapper<server.dto.ExternalCalendarPeek>>(props.peekICalendarUrl, {
        iCalendarUrl: props.value,
        clientId,
      }, undefined);
      return response.data;
    },
    enabled: false,
  });

  const validateUrl = async (): Promise<string | boolean> => {
    if (props.value.length === 0) {
      return RESX.GeneralWarnings.InputMandatory;
    }

    const urlValid = await iCalendarUrlValidator.refetch();
    if (urlValid.data.hasErrors) {
      return urlValid.data.errors[0].message;
    }

    props.onOutcomeChange?.(urlValid.data);

    return true;
  }

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.ExternalCalendar.iCalendarUrl,
    value: props.value,
    validate: validateUrl,
    ref: inputRef,
    type: "manual"
  });

  const onBlur = async () => {
    props.onBlur?.();
  };

  return <InputBase
    ref={inputRef}
    value={props.value}
    onChange={value => { props.onChange(value); }}
    error={validation.error.errorMessage}
    loading={iCalendarUrlValidator.isFetching}
    onBlur={onBlur}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
  />
}